import axios from "axios";

const API_BASE_URL = "https://m.dev-ped.com";

export const checkHealth = async () => {
  try {
    const res = await axios.get(`${API_BASE_URL}/health`);
    return res.data;
  } catch (error) {
    console.error("Error checkHealth:", error);
    throw error;
  }
};
